import type { Thunk, Action } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { ReturnToAddressOverride, FetchReturnToAddressOverrideParams } from '../types';
import parseStatusCode from '../../errors/parseStatusCode';

export interface ReturnToAddressOverrideModel {
  fetchReturnToAddressOverrides: Thunk<
    ReturnToAddressOverrideModel,
    FetchReturnToAddressOverrideParams,
    Injections,
    Promise<ReturnToAddressOverride[]>
  >;
  returnToAddressOverrideActionStart: Action<ReturnToAddressOverrideModel, void>;
  lastAction?: number;
  fetchReturnToAddressOverridesLoading: boolean;
  returnToAddressOverrides: Record<string, ReturnToAddressOverride>;
  returnToAddressOverrideFailure: Action<ReturnToAddressOverrideModel, ApplicationErrorOptions>;
  setReturnToAddressOverrides: Action<ReturnToAddressOverrideModel, ReturnToAddressOverride[]>;
}

export const returnToAddressOverrideModel: ReturnToAddressOverrideModel = {
  returnToAddressOverrides: {},
  returnToAddressOverrideFailure: action((state, payload) => {
    console.error(payload);
  }),
  setReturnToAddressOverrides: action((state, payload) => {
    for (const val of payload) {
      state.returnToAddressOverrides[val.returnToAddressOverrideId] = val;
    }
  }),
  fetchReturnToAddressOverridesLoading: false,
  returnToAddressOverrideActionStart: action((state, payload) => {
    state.lastAction = Date.now();
  }),
  fetchReturnToAddressOverrides: thunk(async (actions, payload, { injections }) => {
    try {
      actions.returnToAddressOverrideActionStart();
      const res = await injections.assetService.fetchReturnToAddressOverrides(payload);
      actions.setReturnToAddressOverrides(res);
      return res;
    } catch (error) {
      actions.returnToAddressOverrideFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured fetching return to address overrides',
        asNotification: true,
      });
    }
  }),
};
